import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedService } from 'src/app/shared/services/shared.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-delete-btn',
    templateUrl: './delete-btn.component.html',
    styleUrls: ['./delete-btn.component.scss'],
    standalone: true,
    imports: [TooltipModule]
})
export class DeleteBtnComponent implements ICellRendererAngularComp {
  params: any;
  deleteBtnVisible = false;
  disabled = false;
  /** Tooltip text shown on hover. Set via cellRendererParams.tooltip; falls
   * back to a generic "Delete" so callers don't have to spell it out. */
  tooltip: string = 'Delete';


  constructor(public sharedService: SharedService) { }

  agInit(params: any): void {
    this.params = params;
   // if (params.data['category'] || params.data['product_service'] ) {
      this.deleteBtnVisible = true;
   // }
    if (params?.tooltip) this.tooltip = params.tooltip;
      this.disabled = !!params?.disabled;

  }
  refresh(params?: any): boolean {
    return true;
  }

  // Button functions
  deleteClick() {
    if (this.disabled) return;
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.node.rowIndex,
    };
    this.params.deleteItemClick(rowData);
  }
}
